import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api.js';
import { t } from '../i18n.js';
import { StappenKaart } from './Beveiligingsstatus.jsx';

/**
 * **Compliance › Volgende stappen**: de acties die uit de beveiligingsstatus volgen, als een eigen
 * pagina. Zelfde gegevens als het statusoverzicht (`api.status`); voor de klant zelf en meekijken via
 * `StappenVoorKlant` in Klant.jsx.
 */
function Laden({ q }) {
  if (q.isPending) return <p className="muted">{t('Laden…')}</p>;
  if (q.isError) return <div className="melder rood">{t(q.error.message)}</div>;
  return <StappenKaart d={q.data.data} />;
}

/** Voor de klant zelf en meekijken. */
export function StappenVoorKlant({ haal, sleutel }) {
  const q = useQuery({ queryKey: [...sleutel, 'status'], queryFn: haal, refetchInterval: 5 * 60_000 });
  return <Laden q={q} />;
}

function EenKlant({ id }) {
  const q = useQuery({ queryKey: ['status', id], queryFn: () => api.status(id), refetchInterval: 5 * 60_000 });
  return <Laden q={q} />;
}

/** Medewerkers: de gekozen klant, of bij Alle klanten eerst een klant kiezen. */
export default function VolgendeStappen({ klant }) {
  const [gekozen, kies] = useState(null);
  const lijst = useQuery({ queryKey: ['status', 'klanten'], queryFn: api.statusKlanten, enabled: klant === 'alle' && !gekozen });
  if (klant !== 'alle') return <EenKlant id={klant} />;
  if (gekozen) return <><button type="button" className="btn bs-terug" onClick={() => kies(null)}>← {t('Alle klanten')}</button><EenKlant id={gekozen} /></>;
  return (
    <>
      <div className="page-head"><div><h1>{t('Volgende stappen')}</h1>
        <p className="sub">{t('Kies een klant voor de acties die uit de beveiligingsstatus volgen.')}</p></div></div>
      {lijst.isPending ? <p className="muted">{t('Laden…')}</p> : lijst.isError ? <div className="melder rood">{t(lijst.error.message)}</div> : (
        <section className="card">
          <table>
            <thead><tr><th>{t('Klant')}</th><th>{t('Score')}</th></tr></thead>
            <tbody>{lijst.data.data.map((r) => (
              <tr key={r.tenant.id} className="bs-rij" onClick={() => kies(r.tenant.id)}>
                <td><button type="button" className="bs-link" onClick={() => kies(r.tenant.id)}>{r.tenant.name}</button></td>
                <td>{r.score}</td>
              </tr>
            ))}</tbody>
          </table>
        </section>
      )}
    </>
  );
}
